var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLecturerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "url(#pattern0_914_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_914_10",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_914_10",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_914_10",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACe0lEQVR4nO2ZS27UQBRFPeGzCFbARwxYANOmnhgg6mUaUhVlFnYSRBMEElvhIzGCIRKfhQSGQUHVSgshoN1x275u+xyppJ60VbrH75X9XFUAAAAAAAA13PNHtyymefD0xWL+UVb5HTw/tZ10kwA7YjY7vBI8vQgx/TTPZ/9awfOpxfTc3S93tY/Jhm8xv/tf8H+v9BYJLRJifrl++MtqSMdt7mHSPX9V21nVju4/3L9Rd3274HVlq5x3nj8Gz49LR+jv7i+Ha+NNpyd11zd1sA1WiPnT7MH+tV4EmOevG2z08xgF2FJCH5UQPJ803qTnk7EKsIWEdIgAF0qI6UPnAmhBeaMKlx7CwfPRGoLPtnl1LqCMFxZvuBcP/3Tme9cR0AJlvNCgP86rEWDqCiiUsULw/Gb98PPrOwcHl6oRYEMQ8FtCOl7Vjs6HcfOxhD8oAUvKeKG84ZaXrODp+2ItfuejdXr+tmFDEzA1DAFaECAGAVMXYDt7t83zM4vp2/lMXP72aT0GIhNwd3f3aoj5VZOPMQhoIXyL+b06TJtqBZQ7Xx2kTVVA6fnb1nZsTALKuEEdok1ZwOJpZwBB2lQFlNmOOkSbsoBtC6hrECAGAWIQIAYBYhAgBgFiECAGAWIQIAYBYhAgBgE1dD2bQkANCBj4uNioAASM+nuAUQEIaBUq4E94CqqBFtTzU4cNfFWbot6gDSBEBLg+SCrA9WF2UeG0IEcAZ8Aq1HeIDaCN0IJcH+Rgz4Cu/z95ECAGAWIQIAYBYhAgBgFiECAGAWIQIAYBYhAgBgFiECAGAWIQIAYBYhAgBgFiECAGAWIQIAYBYhAAAAAAAABQdcovQwsd66XK+pAAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLecturerIcon);
export default __webpack_public_path__ + "static/media/lecturer-icon.ba7cfc81abd9224a8d9e688d4bacd240.svg";
export { ForwardRef as ReactComponent };